export const scholaMatchLink = '/schola-match-fo';
